export default function UrlConverter(initModel)
{
  const tags =
        {
          A: 'href',
          AREA: 'href',
          IMG: 'src',
          EMBED: 'src',
          IFRAME: 'src',
          SCRIPT: 'src',
          TABLE: 'background'
        },
        maxUrlLength = 2083;

  let container;


  const init = () =>
  {
    //container = document.createElement('DIV');
    container = document.implementation.createHTMLDocument('UrlConverterContainer').body;
  };


  const collectTokens = (domContainer, domains) =>
  {
    const domainReg = new RegExp('://(?:' + domains.join("|") + ')(?:[^A-Za-z0-9-.]|$)', 'i'),
          tokens = [],
          a = [];

    let item,
        id,
        att,
        attVal,
        links;

    for (let k in tags)
    {
      a.push(k);
    }

    links = domContainer.querySelectorAll(a.join(', '));

    for (let i = 0, len = links.length; i < len; i++)
    {
      item = links[i];
      att = tags[item.tagName];
      attVal = item.getAttribute(att);

      if (!attVal || attVal.length > maxUrlLength || !domainReg.test(attVal))
      {
        continue;
      }

      id = guid();
      tokens.push(
        {
          id: id,
          link: item.getAttribute(att)
        });

      item.setAttribute(att, id);
    }

    links = domContainer.querySelectorAll('*[style*="url("]');

    for (let i = 0, len = links.length; i < len; i++)
    {
      item = links[i];
      attVal = item.style.backgroundImage;

      if (!attVal || attVal.length > maxUrlLength || !domainReg.test(attVal))
      {
        continue;
      }

      id = guid();
      tokens.push({ id: id, link: attVal });
      item.style.backgroundImage = "url('" + id + "')";
    }

    return tokens;
  };


  const replaceInText = (txt, tokens, domains) =>
  {
    for (let i = 0; i < tokens.length; i++)
    {
      txt = txt.replace(tokens[i].id, makeLinkRelative(tokens[i].link, domains));
    }

    return txt;
  };


  const makeLinkRelative = (link, domains) =>
  {
    const isBg = link.indexOf('url(') > -1;
    let dPos = getDomainPosition(link.toLowerCase(), domains);

    // make relative
    if (isBg)
    {
      link = stripBgUrl(link, dPos);
      dPos = getDomainPosition(link, domains);
    }

    link = link.substr(dPos.idx + dPos.len).trim();

    if (link === '')
    {
      link = '/';
    }

    return link;
  };


  const getDomainPosition = (link, domains) =>
  {
    let idx,
        dLen;

    for (let j = 0; j < domains.length; j++)
    {
      idx = link.indexOf(domains[j]);

      if (idx > -1)
      {
        dLen = domains[j].length;
        break;
      }
    }

    return(
    {
      idx: idx,
      len: dLen
    });
  };


  const stripBgUrl = (link, pos) =>
  {
    link = link.substr(pos.idx, link.length-pos.idx-1); // remove last
    link = link.trim();

    if (link.lastIndexOf("'") === (link.length -1))
    {
      return link.substr(0, link.length-1);// remove last
    }

    if (link.lastIndexOf('"') === (link.length -1))
    {
      return link.substr(0, link.length-1);// remove last
    }

    if (link.lastIndexOf("&quot;") === (link.length -6))
    {
      return link.substr(0, link.length-6);// remove last 6
    }

    return link;
  };


  const guid = () =>
  {
    let str = 'data:image/png;base64,';

    for (let i = 0; i < 8; i++)
    {
      str += Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
  };


  this.convertUrls = (text, domains) =>
  {
    container.innerHTML = text;
    domains.forEach((str, ind) => domains[ind] = str.toLowerCase());

    return replaceInText(container.innerHTML, collectTokens(container, domains), domains);
  };


  init();
}
